export const DEFAULT_SELECTED_PROJECT_ID = null;
